import React from 'react';
import { cn } from '../../utils/cn';
import type { ContainerProps } from '../../types/components';

const maxWidthClasses = {
  sm: 'max-w-screen-sm',
  md: 'max-w-screen-md',
  lg: 'max-w-screen-lg',
  xl: 'max-w-screen-xl',
  '2xl': 'max-w-screen-2xl',
  full: 'max-w-full',
};

const paddingClasses = {
  sm: 'px-4',
  md: 'px-6',
  lg: 'px-8',
  xl: 'px-10',
};

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (
    {
      maxWidth = 'xl',
      centered = true,
      padding = 'md',
      children,
      className,
      testId,
      ...props
    },
    ref
  ) => {
    const baseClasses = ['w-full'];
    
    const maxWidthClass = maxWidthClasses[maxWidth] || maxWidthClasses.xl;
    const paddingClass = paddingClasses[padding] || paddingClasses.md;

    const classes = cn(
      baseClasses,
      maxWidthClass,
      paddingClass,
      {
        'mx-auto': centered,
      },
      className
    );

    return (
      <div
        ref={ref}
        className={classes}
        data-testid={testId}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Container.displayName = 'Container';